import '../styles/social-icons.css';
import socialLinks from '../data/socialLinks.json';
import { Link } from 'react-router-dom';
import GoogleTagManager from '../components/GoogleTagManager';
import { GTM_ID } from '../config/analytics';

function Footer() {
  return (
    <footer className="footer">
      <GoogleTagManager id={GTM_ID} />
      <div className="footer-content">
        <div className="footer-brand">
          <img src="/images/lwt.png" alt="Lead With Tech" style={{ width: '50px', height: 'auto' }} />
          <p>
            Guiding software professionals to grow into impactful tech leaders,
            forward-thinking architects, and AI-powered developers
          </p>
          <div className="social-links">
            {socialLinks.links.map((link) => (
              <a 
                key={link.platform}
                href={link.url}
                className={`social-icon ${link.platform}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.platform.charAt(0).toUpperCase() + link.platform.slice(1)}
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" 
                     dangerouslySetInnerHTML={{ __html: link.icon }} />
              </a>
            ))}
          </div>
        </div>

        <div className="footer-section">
          <h3>COMPANY</h3>
          <ul className="footer-links">
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>GET CONNECTED</h3>
          <ul className="footer-links">
            <li><a href="/community">Join Our Community</a></li>
            <li><a href="/copilot">GitHub Copilot Workshop</a></li>
            {/* <li><a href="/labs">Hands On Labs</a></li>
            <li><a href="/gh300">GH-300 Readiness</a></li> */}
          </ul>
        </div>

        <div className="footer-section">
          <h3>SUPPORT</h3>
          <ul className="footer-links">
            <li><Link to="/terms">Terms and Conditions</Link></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/refund">Cancellation and Refund Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom" style={{ textAlign: 'center', padding: '12px 0', background: 'transparent' }}>
        <p className="copyright" style={{ margin: 0, fontSize: '1rem', color: '#fff', fontWeight: 500 }}>
          &copy; {new Date().getFullYear()} Lead With Tech. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;